import { Circle, CircleCheck } from 'lucide-react';
import cn from 'classnames';
import type { PasswordValidation } from '../types';

interface PasswordRulesProps {
  /** 密码验证状态 */
  validation: PasswordValidation;
  /** 自定义类名 */
  className?: string;
}

interface RuleItemProps {
  /** 是否验证通过 */
  valid: boolean;
  /** 规则文案 */
  text: string;
}

/**
 * 单条规则项
 */
function RuleItem({ valid, text }: RuleItemProps) {
  return (
    <div className="flex items-center gap-[4px]">
      {valid ? (
        <CircleCheck className="h-[16px] w-[16px] text-[#10b981]" />
      ) : (
        <Circle className="h-[16px] w-[16px] text-[#737373]" />
      )}
      <span
        className={cn(
          'text-[12px] font-normal leading-[1.5] tracking-[0.18px]',
          valid ? 'text-[#10b981]' : 'text-[#737373]'
        )}
      >
        {text}
      </span>
    </div>
  );
}

/**
 * 密码规则提示组件
 */
export function PasswordRules({ validation, className }: PasswordRulesProps) {
  return (
    <div className={cn('flex flex-col gap-[4px]', className)}>
      <RuleItem valid={validation.lengthValid} text="Between 8 and 20 characters" />
      <RuleItem valid={validation.hasNumberAndLetter} text="At least 1 number and 1 letter" />
    </div>
  );
}

export default PasswordRules;
